module.exports = __webpack_public_path__ + "static/media/red1.050799c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/red1.svg
// module id = 1336
// module chunks = 31